export const CategoryFr = {
  "Categories": "Categories",
  "Categorie": "Categorie",
}